import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

const WrapperStyleSquare = css`
  ${QUERIES.largeTabletAndUp} {
    padding-top: 100%;
    position: relative;
    background: ${themeStyle.varInkSuperLight};
  }
`;

export const ImageWrapper = styled.a<{
  canClick: boolean;
  isNewsfeed?: boolean;
}>`
  position: relative;
  border-radius: ${themeStyle.radiusMedium};
  cursor: ${({ canClick }) => (canClick ? 'default' : 'pointer')};
  grid-area: image;

  ${({ isNewsfeed }) => !isNewsfeed && WrapperStyleSquare}
`;

// set aspect-ratio to 1. `aspect-ratio: 1` isn't completly supported on safari yet
const BoxStyleSquare = css`
  ${QUERIES.largeTabletAndUp} {
    position: absolute;
    top: 0;
    padding: 48px;
    width: 100%;
    height: 100%;

    &:after {
      display: none;
    }
  }
`;

// center the image
export const Box = styled.div<{ isNewsfeed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    border-radius: ${themeStyle.radiusMedium};
    border: 1px solid ${themeStyle.varInkLight};
  }

  ${({ isNewsfeed }) => !isNewsfeed && BoxStyleSquare}
`;

const ImageShadow = css`
  ${QUERIES.largeTabletAndUp} {
    box-shadow: ${themeStyle.varShadowMedium};
  }
`;

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  backgroundColor?: string;
  imgHeight?: number;
  isPortrait?: boolean;
  isNewsfeed?: boolean;
  srcSet: string;
};

export const Image = styled.img.attrs<ImageProps>(
  ({ srcSet, backgroundColor, imgHeight }) => {
    return {
      srcSet,
      loading: 'lazy',
      crossOrigin: 'anonymous',
      style: {
        backgroundColor,
        height: imgHeight && `${imgHeight}px`,
      },
    };
  }
)`
  display: block;
  user-drag: none;
  border-radius: ${themeStyle.radiusMedium};
  width: ${({ isPortrait }) => (isPortrait ? 'unset' : '100%')};
  height: ${({ isPortrait }) => (isPortrait ? '100%' : 'unset')};
  max-height: 720px;
  max-width: 100%;
  object-fit: cover;
  min-height: 10px; // NOTE: it's a fix for chrome optimization to not load invisible (e.g. 0 height) images

  ${({ isNewsfeed }) => !isNewsfeed && ImageShadow}
`;
